export default __webpack_public_path__ + "static/media/softuni_logo.82226036.png";